import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig.tsx';

export default function TeamOneReal() {
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const fetchAgents = async () => {
            try {
                console.log('Iniciando búsqueda de agentes...');
                
                // Obtener asesores usando el mismo patrón que agents.tsx
                const asesorQuery = query(
                    collection(db, 'asesor'),
                    where('activo', '==', true),
                    limit(4)
                );
                const asesorSnapshot = await getDocs(asesorQuery);
                const asesores = asesorSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                    type: 'asesor'
                }));
                console.log('Asesores encontrados:', asesores.length);

                // Obtener asociados usando el mismo patrón que asociados.tsx
                const asociadoQuery = query(
                    collection(db, 'asociado'),
                    where('activo', '==', true),
                    limit(4)
                );
                const asociadoSnapshot = await getDocs(asociadoQuery);
                const asociados = asociadoSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                    type: 'asociado'
                }));
                console.log('Asociados encontrados:', asociados.length);

                // Combinar y limitar a 8 agentes
                const allAgents = [...asesores, ...asociados].slice(0, 8);
                console.log('Total agentes:', allAgents.length);
                setAgents(allAgents);
            } catch (error) {
                console.error('Error cargando agentes:', error);
                
                // Fallback: intentar sin filtros
                try {
                    const asesorFallback = await getDocs(query(collection(db, 'asesor'), limit(2)));
                    const asociadoFallback = await getDocs(query(collection(db, 'asociado'), limit(2)));
                    
                    const fallbackAgents = [
                        ...asesorFallback.docs.map(doc => ({ id: doc.id, ...doc.data(), type: 'asesor' })),
                        ...asociadoFallback.docs.map(doc => ({ id: doc.id, ...doc.data(), type: 'asociado' }))
                    ];
                    
                    setAgents(fallbackAgents);
                    console.log('Fallback agentes:', fallbackAgents.length);
                } catch (fallbackError) {
                    console.error('Error en fallback de agentes:', fallbackError);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchAgents();
    }, []);

    if (loading) {
        return (
            <div className="row justify-content-center g-4">
                {[...Array(4)].map((_, index) => (
                    <div key={index} className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                        <div className="agents-grid card-agents rounded-3 shadow">
                            <div className="text-center p-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Cargando...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="row justify-content-center g-4">
            {agents.map((agent, index) => (
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12" key={index}>
                    <div className="agents-grid card-agents rounded-3 shadow d-flex flex-column" style={{ height: '100%' }}>
                        <div className="agents-grid-wrap">
                            <div className="fr-grid-thumb mx-auto text-center mt-5 mb-3">
                                <Link
                                    to={agent.type === 'asesor' ? `/agent-page/${agent.id}` : `/asociado-page/${agent.id}`}
                                    className="d-inline-flex p-1 circle border"
                                >
                                    {agent.foto ? (
                                        <img src={agent.foto} className="img-fluid circle" width="130" alt={agent.nombre} />
                                    ) : (
                                        <div className="bg-light circle d-flex align-items-center justify-content-center" style={{ width: '130px', height: '130px' }}>
                                            <i className="fas fa-user fa-3x" style={{ color: '#29866b' }}></i>
                                        </div>
                                    )}
                                </Link>
                            </div>
                            <div className="fr-grid-deatil text-center" style={{ minHeight: 55, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                <div className="fr-grid-deatil-flex">
                                    <h5 className="fr-can-name mb-0">
                                        <Link to={agent.type === 'asesor' ? `/agent-page/${agent.id}` : `/asociado-page/${agent.id}`}>
                                            {agent.nombre}
                                        </Link>
                                    </h5>
                                    <span className="agent-property text-muted-2">
                                        {agent.type === 'asesor' ? 'Asesor Inmobiliario' : 'Asociado AMPI'}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="fr-grid-info d-flex align-items-center justify-content-between px-4 py-4 mt-auto">
                            <div className="fr-grid-sder">
                                <ul className="p-0">
                                    <li>
                                        <strong>Teléfono:</strong>
                                        <span className="fw-medium text-primary ms-2">{agent.telefono || 'No disponible'}</span>
                                    </li>
                                    <li>
                                        <div className="fr-can-rating">
                                            {[1, 2, 3, 4, 5].map((star) => (
                                                <i
                                                    key={star}
                                                    className={`fas fa-star fs-xs ${star <= Math.round(agent.calificacion || 0) ? 'text-warning' : 'text-muted'}`}
                                                    style={{ margin: '0 2px' }}
                                                ></i>
                                            ))}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="fr-grid-deatil-flex-right flex-shrink-0">
                                <div className="agent-email">
                                    <a
                                        href={`mailto:${agent.correo}`}
                                        className="rounded text-icon bg-light-email"
                                        style={{ width: 38, height: 38, fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                        <i className="fa-solid fa-envelope-circle-check"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}